import { jsx as _jsx } from "react/jsx-runtime";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { RedirectionLinkCard } from "../RedirectionLinkCard/RedirectionLinkCard";
import styles from "./List.module.scss";
export const List = ({ items }) => {
    return (_jsx("ul", { className: styles.list, children: items?.map(({ title, link, isArrowHidden }) => {
            const dispatchGTMEvent = () => {
                dispatchTrackingEvent(TrackingEvents.TrackingMenuNavigationClick, { menu_link: title });
            };
            return (_jsx(RedirectionLinkCard, { variant: "list", title: title, link: link, onClick: dispatchGTMEvent, className: styles.item, isArrowHidden: isArrowHidden }, title));
        }) }));
};
//# sourceMappingURL=List.js.map